var cpGaCollector = cpGaCollector || {};
(function (obj) {
    var links = [];
    var actionAttr = 'data-gac-action';
    var categoryAttr = 'data-gac-category';
    var labelAttr = 'data-gac-label';
    obj.init = function () {
        if (typeof gtag !== 'undefined') {
            links = $('a[data-gac-label]');
            if (links.length) {
                parseLinks();
            }
        }
    }

    var parseLinks = function () {
        $.each(links, function (_index, el) {
            var action = el.getAttribute(actionAttr) || 'click';
            var category = el.getAttribute(categoryAttr) || 'link click';
            var label = el.getAttribute(labelAttr);
            $(this).on('click', function (_event) {
                gtag('event', action, {
                    'event_category': category,
                    'event_label': label
                });
            });
        });
    }
})(cpGaCollector);